var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageVenueFilter',{attrs:{"value":_vm.venueId},on:{"input":function($event){return _vm.$store.dispatch('pos/general/selectVenueId', $event)}}},[(_vm.venueId)?_c('PriceShiftWindows',{attrs:{"venueId":_vm.venueId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }